module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_sola-ba7e137f8ce235db1d3ffa2279257580.svg";